import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "jstree";
import "jstree/dist/themes/default/style.css";

export default function AgentTree({
  user,
  setUserList,
  setFilterList,
  onAgentClick,
  onAgentInfo,
}) {
  const [searchOptions, setSearchOptions] = useState([]);
  const searchInputRef = useRef();

  const findPrefixByUserId = (node, targetUserId) => {
    if (!node) return null;
    if (node.myId === targetUserId && node.Prefix) return node.Prefix;
    if (node.userId === targetUserId && node.prefix) return node.prefix;
    if (node.agents && Array.isArray(node.agents)) {
      for (const agent of node.agents) {
        const found = findPrefixByUserId(agent, targetUserId);
        if (found) return found;
      }
    }
    return null;
  };

  useEffect(() => {
    if (!user) return;

    const buildTreeHTML = (user) => {
      const nodes = [];
      const nodesSet = new Set();

      const buildNode = (node) => {
        const levelText = node.level === "0" ? "super" : `M${node.level}`;
        const badgeClass = node.level === "0" ? "super" : `M${node.level}`;
        const nodeId = `agent-${node.userId}`;
        if (!nodesSet.has(nodeId)) {
          nodes.push({ id: nodeId, label: node.userId });
          nodesSet.add(nodeId);
        }

        const children = (node.agents || []).map(buildNode).join("");
        const usersData = encodeURIComponent(JSON.stringify(node.users || []));

        return `
          <li id="${nodeId}" data-users="${usersData}">
            <span class="badge ${badgeClass}">${levelText}</span>
            <span class="ms-1">${node.userId} (KRW)</span>
            <div class="memNum">
              <span class="badge" title="에이전트수">${node.agentsCount}</span>
              <span class="badge" title="회원수">${node.usersCount}</span>
            </div>
            ${children ? `<ul>${children}</ul>` : ""}
          </li>
        `;
      };

      const rootId = `agent-${user.myId}`;
      nodes.push({ id: rootId, label: user.myId });
      const rootUsers = encodeURIComponent(JSON.stringify(user.users || []));
      const html = `
        <ul>
          <li id="${rootId}" data-users="${rootUsers}">
            <span class="badge ${
              user.myLevel === "0" ? "super" : `M${user.myLevel}`
            }">
              ${user.myLevel === "0" ? "super" : `M${user.myLevel}`}
            </span>
            <span class="ms-1">${user.myId} (KRW)</span>
            <div class="memNum">
              <span class="badge" title="에이전트수">${
                user.myAgentsCount
              }</span>
              <span class="badge" title="회원수">${user.myUsersCount}</span>
            </div>
            ${
              user.agents?.length
                ? `<ul>${user.agents.map(buildNode).join("")}</ul>`
                : ""
            }
          </li>
        </ul>
      `;
      return { html, nodes };
    };

    const { html, nodes } = buildTreeHTML(user);
    setSearchOptions(nodes);

    $("#custom-icon-tree").jstree("destroy").empty().html(html);
    $("#custom-icon-tree").jstree({
      core: {
        themes: { variant: "large" },
        html_titles: true,
      },
      plugins: ["wholerow"],
    });

    // ✅ select_node 이벤트 (중복 방지용 off 추가)
    $("#custom-icon-tree")
      .off("select_node.jstree")
      .on("select_node.jstree", function (e, data) {
        const nodeId = data.node.id;
        const clickedUserId = nodeId.replace("agent-", "");
        const foundPrefix = findPrefixByUserId(user, clickedUserId);

        if (foundPrefix && typeof onAgentClick === "function") {
          onAgentClick(foundPrefix);
        }

        if (typeof onAgentInfo === "function") {
          const nodeEl = $("#" + nodeId);
          const agentsCount = nodeEl
            .find('[title="에이전트수"]')
            .first()
            .text()
            .trim();
          const usersCount = nodeEl
            .find('[title="회원수"]')
            .first()
            .text()
            .trim();
          const levelText = nodeEl.find(".badge").first().text().trim();

          onAgentInfo({
            userId: clickedUserId,
            prefix: foundPrefix,
            agentsCount,
            usersCount,
            level: levelText,
          });
        }

        const nodeEl = data.instance.get_node(data.node, true);
        const usersStr = nodeEl.attr("data-users");
        if (usersStr && setUserList && setFilterList) {
          try {
            const users = JSON.parse(decodeURIComponent(usersStr));
            setUserList(users);
            setFilterList(users);
          } catch (err) {
            console.warn("users 파싱 실패:", err);
          }
        }
      });

    // ✅ jstree-icon 토글
    $("#custom-icon-tree")
      .off("click", ".jstree-icon")
      .on("click", ".jstree-icon", function (e) {
        e.stopPropagation();
        const tree = $("#custom-icon-tree").jstree(true);
        const nodeId = $(this).closest("li").attr("id");
        const node = tree.get_node(nodeId);
        tree.toggle_node(node);
      });

    // ✅ jstree-anchor 선택 + 열기
    $("#custom-icon-tree")
      .off("click", ".jstree-anchor")
      .on("click", ".jstree-anchor", function (e) {
        e.stopPropagation();
        const tree = $("#custom-icon-tree").jstree(true);
        const nodeId = $(this).closest("li").attr("id");
        const node = tree.get_node(nodeId);
        tree.deselect_all();
        tree.select_node(node);
        tree.open_node(node);
      });

    if (setUserList && user.users && setFilterList) {
      setUserList(user.users);
      setFilterList(user.users);
    }
  }, [user]);

  const handleSearch = () => {
    const keyword = searchInputRef.current.value.trim();
    if (!keyword) return;

    const matchId = `agent-${keyword}`;
    const tree = $("#custom-icon-tree").jstree(true);

    if (tree && tree.get_node(matchId)) {
      tree.deselect_all();
      tree.open_node(matchId);
      tree.select_node(matchId);
      tree
        .get_node(matchId, true)[0]
        ?.scrollIntoView({ behavior: "smooth", block: "center" });

      const nodeEl = $("#" + matchId);
      const usersStr = nodeEl.attr("data-users");
      if (usersStr && setUserList) {
        try {
          const users = JSON.parse(decodeURIComponent(usersStr));
          setUserList(users);
        } catch (err) {
          console.warn("users 파싱 실패 (검색):", err);
        }
      }
    }
  };

  return (
    <div className="p-1">
      <div className="form-group mb-2 position-relative">
        <div
          className="btn btn-primary form-icon form-icon-right position-absolute end-0 top-0 bottom-0 d-flex align-items-center px-2"
          onClick={(e) => {
            e.stopPropagation();
            handleSearch();
          }}
          style={{ cursor: "pointer", zIndex: 2 }}
        >
          <em className="icon ni ni-search" />
        </div>
        <input
          type="text"
          list="treeRows"
          className="form-control pe-5"
          placeholder="에이전트 검색"
          ref={searchInputRef}
          onKeyDown={(e) => e.key === "Enter" && handleSearch()}
        />
        <datalist id="treeRows">
          {searchOptions.map((opt) => (
            <option key={opt.id} value={opt.label} />
          ))}
        </datalist>
      </div>

      <div id="custom-icon-tree" />
    </div>
  );
}
